
import NotFound from '../assets/images/notFound.png'

export const API_URL = "https://haldus.kiirguskoolitus.ee/api/v1/"
// export const API_URL = "http://localhost:3044/api/v1/"
export const FILE_API_URL = "https://haldus.kiirguskoolitus.ee/"
// export const API_URL = "https://radisolapi.iosx.in:3044/api/v1/"
// export const API_URL = "http://localhost:3044/api/v1/"
export const NO_IMAGE = NotFound
export const SEGMENT_SIZE = 10000000 // 10mb